import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { supabase } from '../lib/supabase';
import SEOHead from './SEOHead';
import "../styles/categorypage.css";

const CategoryPage = () => {
    const { categoryName } = useParams();
    const [articles, setArticles] = useState([]);
    const [categoryTitle, setCategoryTitle] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                console.log("Fetching category:", categoryName);

                // First get the category details
                const { data: category, error: categoryError } = await supabase
                    .from('categories')
                    .select('*')
                    .eq('slug', categoryName)
                    .single(); 

                if (categoryError) {
                    console.error("Category error:", categoryError);
                    throw categoryError;
                }
                
                if (!category) {
                    throw new Error('Category not found');
                }

                console.log("Found category:", category);
                setCategoryTitle(category.name);

                // Then get all articles in this category
                const { data: articlesData, error: articlesError } = await supabase
                    .from('articles')
                    .select('id, title, description, slug, published_at, featured_image')
                    .eq('category_id', category.id)
                    .order('published_at', { ascending: false });

                if (articlesError) {
                    console.error("Articles error:", articlesError);
                    throw articlesError;
                }

                console.log("Found articles:", articlesData);

                if (articlesData && articlesData.length > 0) {
                    const articlesWithDetails = articlesData.map((article) => ({
                        id: article.id,
                        title: article.title,
                        description: article.description,
                        slug: article.slug,
                        categoryName: category.name,
                        featured_image: article.featured_image
                    }));

                    setArticles(articlesWithDetails);
                } else {
                    setError("No articles found for this category.");
                }
            } catch (err) {
                console.error("Error fetching articles:", err);
                setError(err.message || "Failed to load articles.");
            } finally {
                setLoading(false);
            }
        };

        if (categoryName) {
            fetchArticles();
        }
    }, [categoryName]);

    if (loading) return <div>Loading category...</div>;
    if (error) return <div>{error}</div>;

    return (
        <section className="category-page">
            <SEOHead
                title={`${categoryTitle} - Sleep Articles & Advice`}
                description={`Browse our expert articles about ${categoryTitle.toLowerCase()}. Science-backed advice and practical tips to help you sleep better.`}
                path={`/category/${categoryName}`}
            />
            <h1 className="category-title">{categoryTitle}</h1>
            <div className="articles-grid">
                {articles.map((article) => (
                    <Link
                        key={article.id}
                        to={`/article/${article.slug}`}
                        className="article-card"
                        style={{
                            backgroundImage: article.featured_image
                                ? `url(${article.featured_image})`
                                : `url(/assets/featured-bg/${article.slug}.jpg), url(/assets/featured-bg/${article.slug}.png)`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    >
                        <div className="article-content">
                            <h3 className="article-card-title">{article.title}</h3>
                        </div>
                        <p className="article-card-description">{article.description}</p>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default CategoryPage;
